import React from 'react';
import { useLocation } from 'react-router-dom';

import { ImagePreloader } from '~src/ts/ImagePreloader';

export const PRELOAD_IMAGES_INITIAL_WAIT = 1000;

/**
 * A react hook which preloads images one second after the first navigation.
 * The call to preload the images should happen only once, and should not repeat on subsequent navigations.
 * This must be called in a descendant of a Router component.
 */
export function usePreloadDynamicIconImages() {
  const location = useLocation();
  const initialLocation = React.useRef(location);

  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    if(location !== initialLocation.current && !isLoaded) {
      setTimeout(() => ImagePreloader.preloadDynamicIconImages(), PRELOAD_IMAGES_INITIAL_WAIT);
      setIsLoaded(true);
    }
  }, [location, isLoaded]);
}
